import React from "react";
import { useForm } from "react-hook-form";

const ProductAdd = () => {
  const { register, handleSubmit, reset } = useForm();
  const onSubmit = (data) => {
    //   const savedCart = getStoredCart();
    //   data.order = savedCart;

    fetch("https://sleepy-depths-81993.herokuapp.com/items", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.insertedId) {
          alert("Product  Add Successfully");
          reset();
        }
      });
  };
  return (
    <>
      <div className="w-50 m-auto mt-5">
        <h2 className="text-center">Product Add</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div class="mb-3">
            <label class="form-label">Subject</label>
            <input
              {...register("subject")}
              type="text"
              class="form-control"
              placeholder="Product subject"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Image</label>
            <input
              {...register("img")}
              type="text"
              class="form-control"
              placeholder="Enter your image url"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Product Name</label>
            <input
              {...register("name")}
              type="text"
              class="form-control"
              placeholder="Enter your product Name"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Price</label>
            <input
              {...register("price")}
              type="number"
              class="form-control"
              placeholder="Enter product price"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Publisher</label>
            <input
              {...register("publisher")}
              type="text"
              class="form-control"
              placeholder="Enter your Publisher name"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Link</label>
            <input
              {...register("url")}
              type="text"
              class="form-control"
              placeholder="Enter your Link"
            />
          </div>

          <button type="submit" class="btn btn-primary">
            Submit
          </button>
        </form>
      </div>
    </>
  );
};

export default ProductAdd;
